import React, {useEffect, useRef} from "react";
import styles from "./preferences-type.module.css";
import texts from "../../assets/ContextProvider/textsLocalized.json"


const PreferencesType = ({
                           selectedPreferences,
                           setSelectedPreferences,
                           isUnselectedRequiredCategory,
                           setIsUnselectedRequiredCategory
                         }
) => {
  const buttonTypes = [
    {type: "tv", context: texts.preferences["btn-series"]},
    {type: "movie", context: texts.preferences["btn-movie"]}
  ];
  const timeoutTitleRef = useRef(null);


  const handleChangeType = (e) => {
    const selectedType = e.currentTarget.dataset.preferencesType;
    const isSelected = selectedPreferences.type === selectedType;
    let updatedType;

    if (isSelected) {
      updatedType = "";
    } else {
      updatedType = selectedType;
    }

    setSelectedPreferences(prev => ({
      ...prev,
      type: updatedType
    }))
  };

  useEffect(() => {
    timeoutTitleRef.current = setTimeout(() => {
      setIsUnselectedRequiredCategory(prev => ({...prev, type: false}));
    }, 1250);

    return () => {
      clearTimeout(timeoutTitleRef.current);
    }
  }, [isUnselectedRequiredCategory.type]);


  return (
    <>
      <div className={`${styles["preferences-type-title"]}
                       ${isUnselectedRequiredCategory.type ? `${styles["unselected"]}` : ""}`}>
        {texts.preferences.type}
      </div>
      <div className={styles["preferences-type-btn-container"]}>
        {buttonTypes.map((item, index) => {
          return (
            <button
              key={index}
              className={`${styles["preferences-type-btn"]}
              ${selectedPreferences.type === item.type ?
                `${styles["preferences-type-btn-selected"]} ${styles["active"]}` : ""}
              `}
              onClick={handleChangeType}
              data-preferences-type={item.type}>
              {item.context}
            </button>
          )
        })}
      </div>
    </>
  )
}

export default PreferencesType;